import React from 'react';

import './styles.css';

export const Icon = ({ icon }) => {
    const { title1, title2 } = icon;
    return (
        <div className="icon">
        	<span>
        		<img src={icon.icon} alt="A lo Venezolano"/>
        	</span>
            <span>
                <h4>{title1.toUpperCase()}</h4>
                <h5>{title2.toUpperCase()}</h5>
            </span>
        </div>
    )
};